import React from 'react'
import {Provider} from 'react-redux'
import store from '../store/configureStore'
import {SocketIOProvider} from "../context/socket";
import {AuthProvider} from "../lib/auth";
import FireBaseProvider from "./firebase";

export const AppProvider = ({children}) => {
    return (
        <React.Suspense fallback={"Loading..."}>
            <AuthProvider>
                <Provider store={store}>
                    <SocketIOProvider>
                        {/*<FireBaseProvider>*/}
                            {children}
                        {/*</FireBaseProvider>*/}
                    </SocketIOProvider>
                </Provider>
            </AuthProvider>
        </React.Suspense>
    )
}